import { createContext, FC, PropsWithChildren, useMemo } from "react";

import { appSettings } from "./app-settings";
import { FileProvider } from "./file-provider";

interface AppProviderContextType {
  fileProvider: FileProvider;
}

export const AppProviderContext = createContext<AppProviderContextType>(
  {} as AppProviderContextType,
);

export const AppProvider: FC<PropsWithChildren> = ({ children }) => {
  const ctxValue: AppProviderContextType = useMemo(
    () => ({
      fileProvider: new FileProvider(appSettings.aws),
    }),
    [],
  );

  return (
    <AppProviderContext.Provider value={ctxValue}>
      {children}
    </AppProviderContext.Provider>
  );
};
